import { Controller, useFormContext } from "react-hook-form";

function CommunicationPrefField() {
  const { control, watch } = useFormContext();

  const emailPreferred = watch("emailPreferred");
  const smsPreferred = watch("smsPreferred");
  const phonePreferred = watch("phonePreferred");

  const hasCommunicationPreference =
    emailPreferred || smsPreferred || phonePreferred;
  return (
    <fieldset>
      <label>Communication Preference</label>
      <div className="checkbox-with-label">
        <Controller
          name="emailPreferred"
          control={control}
          rules={{
            validate: () => hasCommunicationPreference,
          }}
          render={({ field }) => (
            <input
              id="emailPreferred"
              type="checkbox"
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          )}
        />
        <label htmlFor="emailPreferred" className="inline">
          Email
        </label>
      </div>
      <div className="checkbox-with-label">
        <Controller
          name="smsPreferred"
          control={control}
          rules={{
            validate: () => hasCommunicationPreference,
          }}
          render={({ field }) => (
            <input
              id="smsPreferred"
              type="checkbox"
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          )}
        />
        <label htmlFor="smsPreferred" className="inline">
          SMS
        </label>
      </div>
      <div className="checkbox-with-label">
        <Controller
          name="phonePreferred"
          control={control}
          rules={{
            validate: () => hasCommunicationPreference,
          }}
          render={({ field }) => (
            <input
              id="phonePreferred"
              type="checkbox"
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          )}
        />
        <label htmlFor="phonePreferred" className="inline">
          Phone
        </label>
      </div>
      {!hasCommunicationPreference && (
        <span className="input-error">
          Please select at least one communication method
        </span>
      )}
    </fieldset>
  );
}

export default CommunicationPrefField;
